<template>
    <ElementHighlighter v-if="element && ['product_image', 'redirect_link'].indexOf(type) !== -1"
            :type="type" :element="element" :definition="definition" :classes="classes"
            :selected="selected" :active="active" :disabled="disabled"/>
    <TextHighlighter v-else-if="element"
            :type="type" :element="element" :definition="definition" :classes="classes" 
            :selected="selected" :active="active" :disabled="disabled"/>
</template>

<script>
import Vue from 'vue';
import ElementHighlighter from './ElementHighlighter.vue'
import TextHighlighter from './TextHighlighter.vue'
import Proxy from '../../mixins/Proxy'

import CssSelectorGenerator from '../../static/js/css-selector-generator.js'
let CssSelector = new CssSelectorGenerator({ modifier: Proxy.methods.modifySelectorForProxy })

const LABELS = ['product_image', 'campaign_name', 'shipping_price', 'redirect_link']

export default {
  name          : 'Hightlightor',
  components    : { ElementHighlighter, TextHighlighter },
  props         : {
    window      : {},
    changes     : null,
    type        : '',
    definition  : {},
    selected    : false,
    active      : false,
    hover       : false
  },
  mixins        : [ Proxy ],

  data() {
    return {
      element: null
    }
  },
  
  computed: {
    disabled() {
      return LABELS[this.$store.state.rotator.activeType] !== this.type
    },
    classes() {
      const random     = Math.floor(Math.random() * 10000000)
      const newClasses = {
        ['jbo-overlay']                         : true,
        ['jbo-' + 'selector-' + this.type]      : true,
        ['jbo-' + 'step-' + this.definition.i]  : this.definition.i,
        ['jbo-active']                          : this.selected || this.active,
        ['jbo-hover']                           : this.hover,
        ['jbo-disabled']                        : this.disabled,
        
        // Modify the "update" class when dom changes, to force re-renders
        ['jbo-update-' + random]                : this.changes.length
      }
      
      return Object.keys(newClasses).filter((className) => newClasses[className]).join(' ')
    }
  },
  
  beforeMount() {
    this.findElement()
  },
  
  updated() {
    if (this.changes.length)
      this.findElement()
  },
  
  methods: {
    findElement() {
      try {
        const element = this.window.document.querySelector(this.modifySelectorForProxy(this.definition.s))
        
        // If this is an img node that hasn't finished loading, re-call this func once it completes
        if (element && 
            element.nodeName === 'IMG' &&
            (  
               !element.complete || 
               (element.naturalHeight || 0) < 1 ||
               (element.offsetHeight || element.style.pixelHeight || 0) < 1
            )
        )
          return setTimeout(this.findElement, 50)
        
        // Determine if the selector for a node has changed - if so, update it
        if (this.contains(this.element) && this.definition.s !== CssSelector.getSelector(this.element)) {
          return this.$store.dispatch('modifySelection', {
            remove: this.definition,
            add   : { ...this.definition, s: CssSelector.getSelector(this.element) }
          })
        }
        
        this.element = element
      } catch (err) {
        this.element = null
      }
    },
    contains(element) {
      return this.window.document.body.contains(element)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Highlighter.vue?eb94e7d6